/**
 * 自建拼图滑块
 * SliderCaptcha.mount(el, { getUrl, checkUrl, onSuccess, onFail })
 */
(function (global) {
  'use strict';

  function ajax(method, url, data, cb) {
    var xhr = new XMLHttpRequest();
    xhr.open(method, url, true);
    xhr.onreadystatechange = function () {
      if (xhr.readyState !== 4) return;
      var body = null;
      try { body = JSON.parse(xhr.responseText); } catch (e) { body = null; }
      if (xhr.status >= 200 && xhr.status < 300) {
        cb(null, body);
      } else {
        cb(new Error('http ' + xhr.status), body);
      }
    };
    if (method === 'POST') {
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
      var parts = [];
      if (data) {
        for (var k in data) {
          if (Object.prototype.hasOwnProperty.call(data, k)) {
            parts.push(encodeURIComponent(k) + '=' + encodeURIComponent(data[k]));
          }
        }
      }
      xhr.send(parts.join('&'));
    } else {
      xhr.send(null);
    }
  }

  function createEl(tag, cls, html) {
    var el = document.createElement(tag);
    if (cls) el.className = cls;
    if (html != null) el.innerHTML = html;
    return el;
  }

  function Mount(root, options) {
    options = options || {};
    var getUrl = options.getUrl || '/captcha/get';
    var checkUrl = options.checkUrl || '/captcha/check';
    var onSuccess = options.onSuccess || function () {};
    var onFail = options.onFail || function () {};

    root.innerHTML = '';
    root.className = (root.className ? root.className + ' ' : '') + 'slider-captcha';

    var panel = createEl('div', 'slider-captcha-panel');
    var bgImg = createEl('img', 'sc-bg');
    bgImg.alt = 'captcha';
    var blockImg = createEl('img', 'sc-block');
    blockImg.alt = '';
    panel.appendChild(bgImg);
    panel.appendChild(blockImg);

    var bar = createEl('div', 'slider-captcha-bar');
    var track = createEl('div', 'slider-captcha-track');
    var tip = createEl('div', 'slider-captcha-bar-text', '向右拖动滑块完成拼图');
    var btn = createEl('div', 'slider-captcha-btn', '≫');
    bar.appendChild(track);
    bar.appendChild(tip);
    bar.appendChild(btn);

    var refresh = createEl('button', 'slider-captcha-refresh', '刷新验证码');
    refresh.type = 'button';
    var msg = createEl('div', 'slider-captcha-msg');
    var hidden = document.createElement('input');
    hidden.type = 'hidden';
    hidden.name = 'captchaTicket';
    hidden.className = 'slider-captcha-ticket';
    hidden.value = '';

    root.appendChild(panel);
    root.appendChild(bar);
    root.appendChild(refresh);
    root.appendChild(msg);
    root.appendChild(hidden);

    var state = {
      captchaId: '',
      ticket: '',
      blockSize: 42,
      width: 300,
      dragging: false,
      startX: 0,
      curX: 0,
      maxX: 0,
      done: false
    };

    function setMsg(text, type) {
      msg.textContent = text || '';
      msg.className = 'slider-captcha-msg' + (type ? ' ' + type : '');
    }

    function setTicket(t) {
      state.ticket = t || '';
      hidden.value = state.ticket;
    }

    function resetBar() {
      state.dragging = false;
      state.curX = 0;
      state.done = false;
      btn.style.left = '0px';
      btn.className = 'slider-captcha-btn';
      btn.innerHTML = '≫';
      track.style.width = '0px';
      blockImg.style.left = '0px';
      tip.style.visibility = 'visible';
    }

    function load() {
      setTicket('');
      resetBar();
      setMsg('加载中…');
      ajax('GET', getUrl + (getUrl.indexOf('?') >= 0 ? '&' : '?') + '_=' + Date.now(), null, function (err, data) {
        if (err || !data || data.code != 1) {
          setMsg((data && data.msg) || '加载失败', 'err');
          onFail((data && data.msg) || '加载失败');
          return;
        }
        state.captchaId = data.captchaId;
        state.blockSize = data.blockSize || 42;
        state.width = data.width || 300;
        state.maxX = Math.max(0, (panel.clientWidth || state.width) - state.blockSize);
        bgImg.src = data.bgBase64;
        blockImg.src = data.blockBase64;
        blockImg.style.top = (data.y || 0) + 'px';
        blockImg.style.width = state.blockSize + 'px';
        blockImg.style.height = state.blockSize + 'px';
        setMsg('请完成拼图验证');
      });
    }

    function finish(x) {
      state.done = true;
      tip.style.visibility = 'hidden';
      ajax('POST', checkUrl, { captchaId: state.captchaId, x: Math.round(x) }, function (err, data) {
        if (err || !data || data.code != 1) {
          btn.className = 'slider-captcha-btn fail';
          btn.innerHTML = '×';
          setMsg((data && data.msg) || '验证失败', 'err');
          onFail((data && data.msg) || '验证失败');
          setTimeout(load, 600);
          return;
        }
        btn.className = 'slider-captcha-btn ok';
        btn.innerHTML = '✓';
        setTicket(data.captchaTicket);
        setMsg('验证通过', 'ok');
        onSuccess(data.captchaTicket);
      });
    }

    function onMove(clientX) {
      if (!state.dragging || state.done) return;
      var dx = clientX - state.startX;
      if (dx < 0) dx = 0;
      if (dx > state.maxX) dx = state.maxX;
      state.curX = dx;
      btn.style.left = dx + 'px';
      track.style.width = (dx + state.blockSize / 2) + 'px';
      blockImg.style.left = dx + 'px';
    }

    function onUp() {
      if (!state.dragging || state.done) return;
      state.dragging = false;
      if (state.curX < 5) {
        resetBar();
        return;
      }
      // 按设计宽度换算（面板可能缩放）
      var scale = state.width / (panel.clientWidth || state.width);
      finish(state.curX * scale);
    }

    btn.addEventListener('mousedown', function (e) {
      if (state.done) return;
      state.dragging = true;
      state.startX = e.clientX - state.curX;
      tip.style.visibility = 'hidden';
      e.preventDefault();
    });
    document.addEventListener('mousemove', function (e) { onMove(e.clientX); });
    document.addEventListener('mouseup', onUp);

    btn.addEventListener('touchstart', function (e) {
      if (state.done) return;
      state.dragging = true;
      state.startX = e.touches[0].clientX - state.curX;
      tip.style.visibility = 'hidden';
      e.preventDefault();
    }, { passive: false });
    document.addEventListener('touchmove', function (e) {
      if (!state.dragging) return;
      onMove(e.touches[0].clientX);
      e.preventDefault();
    }, { passive: false });
    document.addEventListener('touchend', onUp);

    refresh.addEventListener('click', function () { load(); });

    load();

    return {
      getTicket: function () { return state.ticket || hidden.value || ''; },
      reset: function () { load(); },
      el: root,
      input: hidden
    };
  }

  global.SliderCaptcha = {
    mount: Mount,
    /** 从容器或文档取 ticket */
    getTicket: function (root) {
      if (root) {
        var inp = root.querySelector('.slider-captcha-ticket');
        if (inp && inp.value) return inp.value;
      }
      var any = document.querySelector('.slider-captcha-ticket');
      return any ? any.value : '';
    }
  };
})(typeof window !== 'undefined' ? window : this);



// WEBPACK FOOTER //
// ./src/assets/js/slider-captcha.js